import React, { useState } from "react";
import { Form, Input, Button, message, Spin } from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  MailOutlined,
  LockOutlined,
} from "@ant-design/icons";
import styles from "./LoginForm.module.css";
import AuthService from "../../../services/AuthService";
import { useDispatch } from "react-redux";
import { setLoginData } from "../../../redux/auth/Action";
import { useHistory, Link } from "react-router-dom";
const LoginForm = ({ closeModal }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      // Aquí puedes manejar la lógica de inicio de sesión
      const login = await AuthService.login(values);
      console.log("valor login: ", login.data);
      const {
        token,
        user: {
          id: userId,
          perfil: { id: perfilId },
          nombre,
          apellido,
          username,
          is_clave_provisional,
          empresa_id:empresaId,
        },
      } = login.data.data;

      // Puedes verificar las variables resultantes
      //console.log("Token:", token);
      //console.log("UserID:", userId);
      //console.log("PerfilID:", perfilId);
      //console.log("Nombre:", nombre);
      //console.log("Apellido:", apellido);

      const payload = {
        token,
        userId,
        perfilId,
        nombre,
        apellido,
        username,
        is_clave_provisional,
        empresaId,
      };
      //console.log("valor payload: ", payload);
      dispatch(setLoginData(payload));
      message.success("Inicio de sesión exitoso");
      setLoading(false);
      closeModal();
      //validar por el id del perfil

      if (perfilId == 1) {
        history.push("/empresas/list-empresas");
      }else if(perfilId == 2){
        history.push("/empresas/list-empresas");
      }
      else if(is_clave_provisional === true){
        history.push("/");
      } 
      else {
        //history.push("/home");
      }
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        // El servidor devolvió un código de estado 401, lo que significa credenciales no válidas
        message.error(
          "Credenciales no válidas. Verifica tu nombre de usuario y contraseña."
        );
      } else {
        // Otro tipo de error, puedes manejarlo según tus necesidades
        console.error("Error en el inicio de sesión:", error.message);
        message.error(
          "Error en el inicio de sesión. Por favor, intenta nuevamente."
        );
      }
    }
  };
  return (
    <Spin spinning={loading}>
      <Form onFinish={onFinish}>
        <Form.Item
          name="username"
          rules={[
            { required: true, message: "Ingrese su correo" },
            {
              type: "email",
              message: "Ingrese un correo electrónico válido",
            },
          ]}
        >
          <Input
            className={styles.Input}
            maxLength={50}
            prefix={
              <MailOutlined
                style={{
                  fontSize: "1.3em",
                  position: "absolute",
                  left: "12px",
                  //top: "2px",
                }}
              />
            }
            placeholder="Ingrese su correo"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: "Ingrese la contraseña" }]}
        >
          <Input.Password
            maxLength={16}
            prefix={
              <LockOutlined
                style={{
                  fontSize: "1.3em",
                  position: "absolute",
                  left: "12px",
                  //top: "2px",
                }}
              />
            }
            placeholder="Ingrese la contraseña"
            iconRender={(visible) =>
              visible ? (
                <EyeOutlined
                  style={{
                    fontSize: "1.3em",
                    //position: "absolute",
                    // left: "12px",
                    //top: "2px",
                  }}
                />
              ) : (
                <EyeInvisibleOutlined
                  style={{
                    fontSize: "1.3em",
                    //position: "absolute",
                    // left: "12px",
                    //top: "2px",
                  }}
                />
              )
            }
            className={styles.Input}
          />
        </Form.Item>
        <Form.Item>
          <Link to="/olvido-contraseña">¿Olvidó su contraseña?</Link>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className={styles.BtnLogin}>
            Iniciar sesión
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default LoginForm;
